// extracted by css-extract-rspack-plugin
export default {"ns-combobox__popover":"BwzyIDEsongaAJZB"};